// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JSLp","type":"styles_type__1DHPP","choices":"styles_choices__3qXw-"};